@if (selectedTenant) {
  <section class="container">
    <mat-card class="overview-header">
      <mat-card-title>
        {{ selectedTenant.Text }}
        @if(warehouseEnabled)
          {
          <span class="warehouse-badge">Warehouse Enabled</span>
        }
      </mat-card-title>
      <mat-card-subtitle>//{{ selectedTenant.Value }}</mat-card-subtitle>
      @if (environmentDetails) {
        <mat-card-content>
          Created by <strong>{{ environmentDetails.CreatedBy }}</strong> on
          {{ environmentDetails.CreatedOn }} on the
          <span [class]="'region env-' + environmentDetails.EnvironmentId">{{
            environmentDetails.EnvironmentName
          }}</span>
          environment
        </mat-card-content>
      }
    </mat-card>
    @if (selectedTenantHasAirswebApplication) {
      <mat-card
        class="overview-settings"
        >
        <mat-card-content class="main-content">
          <a data-qa-id="tenant-overview-btn-access-ehs" mat-raised-button class="mat-accent access-btn" (click)="accessAva()">
            <mat-icon>link</mat-icon> Access EHS
          </a>
          @if (selectedTenant.GraphEndpoint) {
            <a
              data-qa-id="tenant-overview-btn-access-neo4j"
              mat-raised-button
              class="mat-primary neo-btn"
              [href]="sanitizedGraphEndpoint"
              target="_blank"
              >
              <mat-icon>build</mat-icon> Access Neo4j
            </a>
          }
          @if (selectedTenant.GraphEndpoint) {
            <a
              data-qa-id="tenant-overview-btn-view-provision-logs"
              mat-raised-button
              (click)="goToProvisionLogs()"
              class="mat-primary provision-log-btn"
              >
              <mat-icon>playlist_play</mat-icon> View Provision Logs
            </a>
          }
          @if (hasCopyConfigLogs) {
            <a
              data-qa-id="tenant-overview-btn-view-copy-config-logs"
              mat-raised-button
              (click)="goToCopyConfigLogs()"
              class="mat-primary provision-log-btn"
              >
              <mat-icon>content_copy</mat-icon> View Copy Config Logs
            </a>
          }
          <br />
          <mat-divider></mat-divider><br />
          <div class="tenant-fields">
            <div>
              @if (hasPermission(permissions.tenantStatus)) {
                <div>
                  <span>
                    <mat-form-field>
                      <mat-label>Tenant status</mat-label>
                      <mat-select
                        data-qa-id="tenant-overview-select-tenant-status"
                        class="mat-primary"
                        [(ngModel)]="selectedTenantStatus"
                        (selectionChange)="onTenantStatusSelect()"
                        >
                        @for (status of tenantStatuses; track status) {
                          <mat-option
                            [value]="status"
                            >
                            {{ status.Text || status.Value }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </span>
                  <div class="error-message-container error">{{ errorMessage }}</div>
                </div>
              }
              @if (hasPermission(permissions.tenantType)) {
                <div>
                  <span>
                    <mat-form-field>
                      <mat-label>Tenant type</mat-label>
                      <mat-select
                        data-qa-id="tenant-overview-select-tenant-type"
                        class="mat-primary"
                        [(ngModel)]="selectedTenantType"
                        (selectionChange)="onTenantTypeSelect()"
                        >
                        @for (type of tenantTypes; track type) {
                          <mat-option [value]="type">
                            {{ type.Text || type.Value }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </span>
                  <div class="error-message-container error">{{ errorMessage }}</div>
                </div>
              }
              @if (hasPermission(permissions.tenantPermissionGroup) && showTenantPermissionGroup) {
                <div
                  >
                  <span>
                    <mat-form-field>
                      <mat-label>Tenant group</mat-label>
                      <mat-select
                        data-qa-id="tenant-overview-select-tenant-group"
                        class="mat-primary"
                        [(ngModel)]="selectedTenantPermissionGroup"
                        (selectionChange)="onTenantPermissionGroupSelect()"
                        >
                        @for (tenantGroup of tenantGroups; track tenantGroup) {
                          <mat-option
                            [value]="tenantGroup"
                            >
                            {{ tenantGroup.displayName }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </span>
                  <div class="error-message-container error">{{ errorMessage }}</div>
                </div>
              }
            </div>
            @if (hasPermission(permissions.tenantAttributes)) {
              <div>
                <div>
                  <mat-form-field>
                    <mat-label>CRM ID</mat-label>
                    <input
                      matInput
                      data-qa-id="tenant-overview-input-crm-id"
                      [value]="selectedTenant.CrmId ?? ''"
                      readonly
                      />
                  </mat-form-field>
                  <div class="error-message-container error">{{ errorMessage }}</div>
                </div>
                <div>
                  <mat-form-field>
                    <mat-label>CRM Name</mat-label>
                    <input
                      matInput
                      data-qa-id="tenant-overview-input-crm-name"
                      [value]="selectedTenant.CrmName ?? ''"
                      readonly
                      />
                  </mat-form-field>
                  <div class="error-message-container error">{{ errorMessage }}</div>
                </div>
                <div>
                  <mat-form-field>
                    <mat-label>Tenant industry</mat-label>
                    <mat-select
                      data-qa-id="tenant-overview-select-tenant-industry"
                      class="mat-primary"
                      [(ngModel)]="selectedTenantIndustry"
                      (selectionChange)="updateTenantAttributes()"
                      >
                      @for (tenantIndustry of tenantIndustries; track tenantIndustry) {
                        <mat-option
                          [value]="tenantIndustry"
                          >
                          {{ tenantIndustry.Text }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <div class="error-message-container error">{{ errorMessage }}</div>
                </div>
                <div>
                  <mat-form-field>
                    <mat-label>Tenant size</mat-label>
                    <mat-select
                      data-qa-id="tenant-overview-select-tenant-size"
                      class="mat-primary"
                      [(ngModel)]="selectedTenantSize"
                      (selectionChange)="updateTenantAttributes()"
                      >
                      @for (tenantSize of tenantSizes; track tenantSize) {
                        <mat-option
                          [value]="tenantSize"
                          >
                          {{ tenantSize.Text }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <div class="error-message-container error">{{ errorMessage }}</div>
                </div>
              </div>
            }
          </div>
          @if (displayOrganisationInformation()) {
            <div>
              <br />
              <mat-divider></mat-divider><br />
              <div>
                <mat-label>Organisation ID&nbsp;:&nbsp;</mat-label>
                <mat-label>{{ organisationId }}</mat-label>
              </div>
            </div>
          }
          <br />
          <mat-divider></mat-divider><br />
          @if (hasPermission(permissions.tenantEcoTranslateSynchronisation)) {
            <div>
              <span>
                <mat-checkbox
                  id="aw_allow_ecotranslate_synchronisation"
                  data-qa-id="tenant-overview-checkbox-ecotranslate"
                  [(ngModel)]="allowEcoTranslateSynchronisation"
                  (change)="onAllowEcoTranslateSynchronisationChange()"
                  aria-label="Allow EcoTranslate Synchronisation"
                  >
                  Allow EcoTranslate Synchronisation
                </mat-checkbox>
              </span>
              <div class="error-message-container error">{{ errorMessage }}</div>
            </div>
          }
          <div>
            <span>
              <mat-checkbox
                id="aw_best_practice"
                data-qa-id="tenant-overview-checkbox-best-practice"
                [(ngModel)]="selectedTenant.BestPracticeTenant"
                (change)="onBestPracticeChange()"
                aria-label="Best Practice Tenant"
                >
                Best Practice Tenant
              </mat-checkbox>
            </span>
            <div class="error-message-container error">{{ errorMessage }}</div>
          </div>
        </mat-card-content>
      </mat-card>
    }
    &nbsp;
    <div>
      <aw-tenant-comments [clientId]="selectedTenant.Value"></aw-tenant-comments>
    </div>
  </section>
}
